import React from 'react';
import cx from 'classnames';

import styles from './Card.module.less';

type CardProps = {
  className: string;
  title: JSX.Element | string;
  dek: JSX.Element | string;
  footer: JSX.Element | string;
};
const Card: React.FC<CardProps> = ({ className, title, dek, footer }): JSX.Element => (
  <div className={cx(styles.container, className)}>
    <h4 className={styles.title}>{title}</h4>
    <div className={styles.dek}>{dek}</div>
    <div className={styles.footer}>{footer}</div>
  </div>
);

export default Card;
